import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { ArrowUpRight } from "@/icons";
import type { CaseConcept } from "@/types/detail";

/** Reusable concept case-study preview (clearly labelled). */
export function CaseStudyPreview({ data }: { data: CaseConcept }) {
  return (
    <div className="grid gap-8 overflow-hidden rounded-[1.5rem] border border-border bg-card lg:grid-cols-2">
      {/* Visual */}
      <div className="relative min-h-[240px] overflow-hidden">
        <div
          className="absolute inset-0"
          style={{ background: `linear-gradient(135deg, ${data.accent}26, ${data.accent}08)` }}
        />
        <div className="absolute inset-0 bg-grid opacity-40" />
        <div className="absolute inset-6 rounded-xl border border-border bg-card/80 p-5 shadow-lg backdrop-blur">
          <div className="flex items-center gap-1.5">
            <span className="h-2 w-2 rounded-full" style={{ background: data.accent }} />
            <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
            <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
          </div>
          <div className="mt-4 grid grid-cols-3 gap-3">
            {data.metrics.map((m) => (
              <div key={m.label} className="rounded-lg bg-muted p-3">
                <p className="font-heading text-lg font-bold text-foreground">{m.value}</p>
                <p className="text-[11px] text-muted-foreground">{m.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-3 space-y-2">
            <div className="h-2 w-3/4 rounded-full bg-muted" />
            <div className="h-2 w-2/3 rounded-full bg-muted" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col p-8 inset-6 rounded-xl border border-border p-5 shadow-lg backdrop-blur">
        <div className="flex items-center gap-2">
          {/* sudip changed concept project to data.category  */}
          <Badge className="rounded-full bg-secondary text-white">{data.category}</Badge>
          {/* sudip */}
          {/* <span className="text-xs font-medium uppercase tracking-[0.12em] text-accent">
            {data.category}
          </span> */}
        </div>
        <h3 className="mt-4 font-heading text-2xl font-bold text-foreground">
          {data.title}
        </h3>
        <p className="mt-3 flex-1 text-[15px] leading-relaxed text-muted-foreground">
          {data.summary}
        </p>
        <div className="mt-5 flex flex-wrap gap-2">
          {data.tech.map((t) => (
            <Badge key={t} variant="secondary" className="rounded-full bg-muted text-muted-foreground">
              {t}
            </Badge>
          ))}
        </div>
        <Link
          to="/case-studies"
          className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:gap-2.5"
        >
          Explore example <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
